<template>
  <div id="app">
    <ProgressBar ref="progressBar" />
    <Header />
    <main class="min-h-screen">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import ProgressBar from './components/ProgressBar.vue'
</script>
